module.exports = __webpack_public_path__ + "static/media/jpg.36dcc70f.svg";